import React, { useState } from "react";
import { IoCopy } from "react-icons/io5";
import { RiShareBoxLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { setUserId, setUserState, setshowcomponents } from "../Store/userslice";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BiHide, BiShowAlt } from "react-icons/bi";
import Loader from "../Loader/Loader";

const Partners = () => {
  //-----states----
  const [visibleItems, setVisibleItems] = useState(6);
  const [showMore, setShowMore] = useState(false);

  //-----Redux states----
  const UserId = useSelector((state) => state.user.UserId);
  const dispatch = useDispatch();
  const PartnersData1 = useSelector((state) => state.user.PartnersData);
  const Partnersdata = PartnersData1.partners;
  //---------
  const data = Partnersdata
    ? Partnersdata.map((activity) => {
        const timestamp = activity.time;
        const date = new Date(timestamp * 1000);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const time = `${year}-${month}-${day} ${hours}:${minutes}`;
        //----sort address
        const address = activity?.userAddress;
        const formattedAddress = address
          ? `${address.substring(0, 6)}...${address.substring(
              address.length - 4
            )}`
          : "..";

        return {
          date: `${formattedDate}`,
          address: `${formattedAddress}`,
          addresscopy: `${address}`,
          time: `${time}`,
          copyIcon: <IoCopy />,
          shareIcon: <RiShareBoxLine />,
          id: `${activity?.userId}`,
          profitBUSD: `${activity?.profitAmount}`,
          partners: `${activity?.partners}`,
        };
      })
    : [];
  //-----------
  const HandleSendId = (e) => {
    dispatch(setUserId(e));
    dispatch(setUserState(true));
    dispatch(setshowcomponents(0));
  };
  //------Copy Function-----
  const handleCopy = (e) => {
    navigator.clipboard.writeText(e).then(
      () => {
        toast("Copied to clipboard!", {
          position: "bottom-left",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      },
      (err) => {
        console.error("Failed to copy: ", err);
      }
    );
  };
  //------Share Function-----
  const handleShare = (e) => {
    window.open(`https://testnet.bscscan.com/address/${e}`, "_blank");
  };

  //-----Show More And Less Table Funtion -------
  //  const toggleShowMore = () => {
  //   if (showMore) {
  //     setVisibleItems(5);
  //   } else {
  //     setVisibleItems(data.length);
  //   }
  //   setShowMore(!showMore);
  // };
  const [showLoader, setshowLoader] = useState(false);
  const toggleShowMore = () => {
    if (showMore) {
      setshowLoader(true);
      setTimeout(() => {
        setVisibleItems(4);
        setshowLoader(false);
      }, 1000);
    } else {
      setshowLoader(true);
      setTimeout(() => {
        setVisibleItems(data.length);
        setshowLoader(false);
      }, 1000);
    }
    setShowMore(!showMore);
  };
  return (
    <>
      <div className="Partners-main-div">
        <div className="partners-header-div">
          <h1>
            Partners{" "}
            <span
              className="partners-header-id"
              onClick={() => HandleSendId(UserId)}
            >
              ID{UserId}
            </span>
          </h1>
          <h1>Filters</h1>
        </div>
        <div className="partners-page-table-div">
          <table className="partners-page-table">
            <thead>
              <tr className="partners-table-data">
                <td>Date:</td>
                <td>Address</td>
                <td>ID</td>
                <td>Profit BUSD</td>
                <td>Partners</td>
              </tr>
            </thead>
            <tbody>
              {data?.slice(0, visibleItems).map((e, index) => (
                <tr key={index} className="partners-table-data">
                  <td>{e.time}</td>
                  <td className="partners-table-address">
                    {e.address}
                    <span
                      onClick={() => handleCopy(e.addresscopy)}
                      className="partners-table-copy-icon"
                    >
                      {e.copyIcon}
                    </span>
                    <span
                      onClick={() => handleShare(e.addresscopy)}
                      className="partners-table-copy-icon"
                    >
                      {e.shareIcon}
                    </span>
                  </td>
                  <td onClick={() => HandleSendId(e.id)}>
                    <span className="partners-table-id">
                      <span className="partners-table-id-span">ID {e.id}</span></span>
                  </td>
                  <td>{e.profitBUSD}</td>
                  <td>{e.partners}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="show-table" onClick={toggleShowMore}>
            <div className="show-table-inner-div">
              <span className="show-table-btn-span">
                {showMore ? (
                  <>
                    {showLoader ? (
                      <Loader />
                    ) : (
                      <>
                        See less <BiHide className="show-table-icon" />
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {showLoader ? (
                      <Loader />
                    ) : (
                      <>
                        See more <BiShowAlt className="show-table-icon" />
                      </>
                    )}
                  </>
                )}
              </span>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default Partners;
